@if (isBestChoice) {
  <div class="sli-banner">{{ 'BEST_CHOICE' | translate }}</div>
}

<div
  class="sli-container text"
  [class.sli-container-lg]="size === 'large'"
  [class.success]="isRecommended"
  [class.top-banner]="isBestChoice"
>
  @if (locationType) {
    <div class="sli-pre-title">
      <!-- Location type (e.g. "Grocery Store", "Hotel" etc.) -->
      <div class="sli-location-type">
        <i class="sli-location-icon"></i>
        <span>{{ locationType | translate }}</span>
      </div>
      <!-- Rating (if location type is enabled this rating will be shown) -->
      <lh-shared-ui-ratings-summary
        [numberOfRatings]="numberOfReviews"
        [averageRating]="averageRating"
      ></lh-shared-ui-ratings-summary>
    </div>
  }

  <!-- Title (e.g. "Luggage Storage Penn Station") -->
  <div class="sli-title">
    <div class="sli-title-text">{{ title }}</div>

    @if (!locationType) {
      <!-- Rating (if location type is disabled this rating will be shown) -->
      <lh-shared-ui-ratings-summary
        [numberOfRatings]="numberOfReviews"
        [averageRating]="averageRating"
      ></lh-shared-ui-ratings-summary>
    }
  </div>

  <div class="sli-post-title">
    <!-- Opening hours -->
    <lh-storage-location-availability
      [storageLocation]="storageLocation"
      [isOpenOnArrival]="isOpen"
      [isFullyBooked]="isFullyBooked"
      [openingHours]="openingHours"
      [nextOpenDay]="nextOpenDay"
      [opensAt]="opensAt"
      [closesAt]="closesAt"
    ></lh-storage-location-availability>

    @if (isFullyBooked || openingHours) {
      <div class="sli-separator">·</div>
    }

    <!-- Location -->
    <div class="sli-location">{{ locationInfo }}</div>
  </div>

  <lh-storage-location-holiday-notice [html]="holidayNoticeHtml"></lh-storage-location-holiday-notice>

  <!-- No multi-day storage  -->
  @if (!isMultiDayStorageAllowed) {
    <div class="sli-overnight">
      <span class="sli-overnight-badge">{{ 'SHORT_TERM_ONLY' | translate }}</span>
      @if (!compactMode) {
        <span class="sli-overnight-text">{{ 'NO_OVERNIGHT_STORAGE' | translate }}</span>
      }
    </div>
  }

  <!-- Badges -->
  <lh-storage-location-badge-list [badges]="badges"></lh-storage-location-badge-list>

  @if (isFooterVisible) {
    <div class="sli-footer">
      <div class="sli-footer-info">
        <!-- Footnote -->
        @if (footnotePart1Html || footnotePart2Html || serviceFeeFootnote) {
          <div class="sli-footnote">
            @if (footnotePart1Html) {
              <span [innerHtml]="footnotePart1Html"></span>
            }
            @if (footnotePart1Html && footnotePart2Html) {
              <span>/</span>
            }
            @if (footnotePart2Html) {
              <span [innerHtml]="footnotePart2Html"></span>
            }
            @if (footnoteTooltipHeaderHtml || footnoteTooltipBodyHtml) {
              <lh-shared-ui-tooltip
                [callToAction]="'i'"
                [header]="footnoteTooltipHeaderHtml"
                [body]="footnoteTooltipBodyHtml"
                [compactMode]="true"
              ></lh-shared-ui-tooltip>
            }
            @if (serviceFeeFootnote) {
              <span class="sli-footnote-fee">{{ serviceFeeFootnote }}</span>
            }
          </div>
        }
        <!-- Actions -->
        <div class="sli-cta">
          <!-- Dropdown with secondary calls to action -->
          @if (secondaryActions?.length > 0) {
            <div class="dropdown" dropdown container="body" autoClose="outsideClick">
              <div class="href" for="shopActionsMenu">
                <button
                  id="toggleShopActionsDropdown"
                  class="btn btn-default"
                  (click)="$event.stopPropagation()"
                  dropdownToggle
                >
                  @if (secondaryActionsMenuTitle) {
                    <span>{{ secondaryActionsMenuTitle | translate }} </span>
                  }
                  <span class="bi bi-caret-down-fill"></span>
                  <!-- <i class="icon-options"></i> -->
                </button>
              </div>
              <ul id="shopActionsMenu" class="dropdown-menu" *dropdownMenu role="menu" aria-labelledby="toggle">
                @for (action of secondaryActions; track action) {
                  <li>
                    <a [id]="'selectShopAction_' + action.callToAction" class="href" (click)="action.onClick($event)">{{
                      action.callToAction | translate
                    }}</a>
                  </li>
                }
              </ul>
            </div>
          }
          <!-- Inline primary calls to action -->
          @for (action of primaryActions; track action) {
            <button
              class="btn btn-primary"
              [class.btn-sm]="compactMode"
              (click)="action.onClick($event)"
              id="cta-{{ index + 1 }}"
            >
              <span>{{ action.callToAction | translate }}</span>
            </button>
          }
        </div>
      </div>
    </div>
  }
</div>
